import React from "react";
import "./App.css";
import Scholars from "./pages/Scholars";
import { Switch, Route } from "react-router-dom";
import { fetchAddressProfile } from "./helpers/getSLP";

export const appVersion = "AbraEx Tools v0.8.1";

function App() {
  // React.useEffect(() => {
  //   fetchAddressProfile(
  //     "0x81df255147806400fbCf431EfD383646A4Ce3D9A"
  //   ).then((res) => console.log(res));
  //   // const AXIE = require("axie");

  //   // let axie = new AXIE("0x81df255147806400fbCf431EfD383646A4Ce3D9A", false);

  //   // axie.getAxie(118088).then((result: any) => console.log(result));
  // }, []);
  // window.location.href = "https://abraex-tools.netlify.app/";
  window.document.title = appVersion;

  return (
    <Switch>
      <Route>
        <Scholars />
      </Route>
    </Switch>
  );
}

export default App;
